export default class BusinessMapUtil
{
    // gongqi.erp.basedata  基础数据 自动构建首页流程图
    
    static defaultline() {
        let line = {"shape":"edge","attrs":{"line":{"stroke":"#1890ff","targetMarker":{"name":"classic","size":8 },"strokeDasharray":0,"style":{ "animation":"ant-line 30s infinite linear"}}},
               "id":"","connector":"normal","router":{"name":""},"zIndex":0,"labels":[{"text":""}],
               "source":{"cell":"","port":"port4"},"target":{"cell":"","port":"port3"}
               }
        return line;
    }

    
    static defaultCell(){
        let cell = {"position":{"x":0, "y":0},"size":{"width":130,"height":85},
                   "attrs":{"body":{"fill":"#fff"},"avatar":{"letterSpacing":0,"id":"","xlinkHref":'../../../static/img/box.png'},"name":{"fontFamily":"Arial","fontSize":13,"text":"","fill":"#696969","letterSpacing":0,"id":""},
                   "explain":{"fontFamily":"Arial","text":"","fill":"#696969","letterSpacing":0}},"shape":"org-node","id":"",
                    "ports":{"groups":{"top":{"position":"top","attrs":{ "circle":{"r":4,"magnet":true,"stroke":"#2D8CF0","strokeWidth":2,"fill":"#fff" }}},
                            "bottom":{ "position":"bottom", "attrs":{"circle":{"r":4,"magnet":true,"stroke":"#2D8CF0","strokeWidth":2, "fill":"#fff" }}},
                            "left":{"position":"left","attrs":{"circle":{"r":4,"magnet":true, "stroke":"#2D8CF0","strokeWidth":2,"fill":"#fff" }}},
                            "right":{"position":"right","attrs":{"circle":{"r":4,"magnet":true,"stroke":"#2D8CF0","strokeWidth":2,"fill":"#fff" }}}
                        },
                        "items":[ {"id":"port1","group":"top" },{"id":"port2", "group":"bottom"},{"id":"port3","group":"left"},{ "id":"port4", "group":"right" }]
                    },
                    "zIndex":1
                }
        return cell;
    } 
    static BusinessMapJSON(appId,mainmenuString){
        var jsonObj = {};
        let main = JSON.parse(mainmenuString);
        jsonObj = this.getBasedataJSON(main);
        return jsonObj;
    }


    static getBasedataJSON(mainMenu){
        window.MenuItemsForBus =[];
        var its = this.authorityMenu(mainMenu.items,null);
        var newMenu  = {'id':"MainMenu",'items':its};
        this.analysisMainMenu(newMenu);
        var xIndex = 0;
        var yIndex = 0;
        var jsonObj = {"cells":[]}
        window.MenuItemsForBus.forEach((item,index)=>{
            let userCell = this.defaultCell();
            if( index !=0 && index%5 == 0){
                yIndex = yIndex+150;
                xIndex = 0;
            }
            userCell.position.x = xIndex;
            userCell.position.y = yIndex;
            userCell.attrs.avatar.id = item.id;
            userCell.attrs.name.text = item.Properties.Label.V;
            userCell.attrs.name.id = item.id;
            userCell.id = this.guid();
            userCell.zIndex = index+1;
            xIndex= xIndex+200;
            jsonObj.cells.push(userCell);
        })
        
        return jsonObj;
    }

    static authorityMenu(items,moudleId){
        for(var i=0;i<items.length;i++)
			{
				var item = items[i];
      			if(item.qname)
      			{
      				if(item.qname=="MenuItem")
      				{	
						if(!window.flatMainMenuToMenuItem.hasOwnProperty(item.id))
						{
							window.flatMainMenuToMenuItem[item.id] = {};
						}
						let _menuKey = moudleId+'.'+item.idInMenu;
						window.flatMainMenuToMenuItem[item.id][_menuKey] = true;
						var isShow=false;   
      					var onlyQuery=false;
      					var visible=item.Properties.Visible.V;
      					if(visible!='false'){
							  if(window.userInfos.isAdmin)
							  {
								isShow = true;
							  }
							  else
							  {
	      						var thisAu=moudleId+'.'+item.idInMenu;
	      						var authorityArr=window.xmlType1SCache[thisAu];
	      						if(authorityArr){
	      							
									if(!authorityArr.del && !authorityArr.visible && !authorityArr.query)
									{
										onlyQuery = true;
									}
									else if(!authorityArr.del && authorityArr.query)
									{
										isShow = true;onlyQuery = true;
									}
									else if(authorityArr.del || authorityArr.query)
									{
										isShow = true;
									}
				      			}
				      		}
      					}else{
                            delete items[i];
                            //items.splice(i,1);
                          }
      					
      					
                        if(!isShow)
                        {
                            //items.splice(i,1);
                            delete items[i];
                        }
      					
      					
      				}else if(item.qname=="MenuSub")
      				{	
      					
      					var isShow=false; 
      					var visible=item.Properties.Visible.V;
      					if(visible=='true'){
      						if(window.userInfos.isAdmin){
	      						isShow=true;
	      					} else{
	      						var thisAu=moudleId+'.'+item.id;
	      						var authorityArr=window.xmlType1SCache[thisAu];
	      						if(authorityArr){
	      							if(!authorityArr.del&&!authorityArr.query&&!authorityArr.visible){
	      								isShow=false;
	      							}else{
	      								isShow=true;
	      							}
	      						}
	      					}
      					}else{
                            //items.splice(i,1);
                            delete items[i];
                        }
      					
      					
						if(isShow)
						  {
                            this.authorityMenu(item.items,moudleId)	
      					}else{
                            //items.splice(i,1);
                            delete items[i];
                          }
      				}
      			}
      			else
      			{	
      				var isShow=false; 
      				var visible=item.Properties.Visible.V;
      				if(visible=='true'){
      					if(window.userInfos.isAdmin){
		      				isShow=true;
		      			}else{
		      				moudleId=item.id; 
			      			var authorityArr=window.xmlType0SCache[moudleId];
			      			if(authorityArr){
			      				if(authorityArr.del){
			      					isShow=true;
			      				}else{
			      					isShow=false;
			      				}
			      			}
		      			}
      				}else{
                        //items.splice(i,1);
                        delete items[i];
                      }
      				
      				
                      if(isShow)
                      {
                        this.authorityMenu(item.items,moudleId)
      				  }else{
                       // items.splice(i,1);
                       delete items[i];
                    }

      			}
			}
            return items;
    }

    static guid() {
        return 'xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static analysisMainMenu(mainMenu){
        if(mainMenu){
            mainMenu.items.forEach((item)=>{
                if(item){
                    item.items.forEach((item2)=>{
                        if(item2){
                            this.analysisMenuItem(item2);
                        }                   
                    })
                }
            })
        }
    }

    static analysisMenuItem(item){
        if(item.qname && item.qname =="MenuItem"){
            window.MenuItemsForBus.push(item);
        }else {
            item.items.forEach((item3)=>{
                if(item3){
                    this.analysisMenuItem(item3);
                }
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/BusinessMapUtil.js